/* Built In Imports */
import { useRouter } from 'next/router';

/* External Imports */
import { Box, Flex, Grid, Icon, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { getCookie } from '@components/Utility/utils';
import config from '@config';
import { ThankYouSt } from '@ieo/Common/CompLangConfig';
import { useTranslation } from '@ieo/Components/Form/ieo/translation';
import { TextContainer } from '@ieo/Components/ThankYou/ThankYouPageElements';
import { mixPanel } from '@utils/Mixpanel';

/* Services */

let mpEventFired = false;

/**
 *
 * @param {Object} pageState
 * @returns
 */
export const ThankYouErrorScreen = ({
  pageState,
  message,
  data,
  lang,
  bodyData,
}) => {
  const router = useRouter();

  // console.log(pageState, message, data, router.query, 'ThankYouErrorScreen');
  const { t } = useTranslation('thank-you');
  const failureSection = bodyData?.find(
    e => e.sectionId === 'payment-failure-message'
  )?.sectionContent;
  const thankyouSection =
    bodyData?.find(e => e.sectionId === 'thank-you-message-new')
      ?.sectionContent ||
    bodyData?.find(e => e.sectionId === 'thank-you-message')?.sectionContent;

  // useEffect(() => {
  //   setIsLoggedIn(authCtx.isLoggedIn);
  //   // console.log('authCtx', authCtx);
  // }, [authCtx.isLoggedIn]);

  /** Mixpanel event */
  if (!mpEventFired) {
    const Mixpanel = mixPanel(router.asPath);
    const mixPanelObj = {
      program_language:
        config.lngList[router.query?.programLanguage?.toLowerCase()],
      program_amount: router.query?.fullPrice,
      currency: router.query?.currency,
      // discounted_amount: router.query?.amount,
      has_whatsapp: router.query?.has_whatsapp,
      // payment_gateway: '',
      // payment_method: '',
      failure_reason:
        router.query?.errCode ||
        (router.query?.errMsg && JSON?.parse(router.query?.errMsg)?.error),
    };
    if (
      router.query?.status === 'ERROR' &&
      router.asPath?.indexOf('/in/') > -1
    ) {
      
      if (Object.keys(Mixpanel)?.length > 0) {
        const cookieName = `mp-event-f-${pageState.transactionId}`;
        const mixPanelCookieObjData =
          getCookie(cookieName) && JSON?.parse(getCookie(cookieName));
        if (!mixPanelCookieObjData) {
          const cookieExpiryDate = new Date(
            new Date().setDate(new Date().getDate() + 1)
          );
          const cookieObjData = { txnId: pageState.transactionId };
          document.cookie = `${decodeURIComponent(cookieName)}=${decodeURIComponent(
            JSON.stringify(cookieObjData)
          )};expires=${cookieExpiryDate.toGMTString()};domain=${
            config.COOKIE_DOMAIN
          };path=/;secure=true;samesite=true;`;
          if (Object.keys(Mixpanel)?.length > 0) {
            Mixpanel.track('ie_registration_failed', mixPanelObj);
            mpEventFired = true;
            if (pageState?.ssoId) {
              Mixpanel?.alias(pageState?.ssoId);
              Mixpanel.identify(pageState?.ssoId);
              Mixpanel.people.set({
                $name: `${pageState?.fname} ${pageState?.lname}`,
                $email: pageState?.email,
              });
            }
          }
        }
      }
    }
  }

  /** Mixpanel event */

  return (
    <Flex
      maxW={'700px'}
      px={{ base: '20px', md: '80px' }}
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      textAlign={'center'}
      height={'full'}
      py={12}
    >
      <Icon width={54} height={54}>
        <svg viewBox="0 0 52 43" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.669922 43.0009L25.9976 0.34375L51.3252 43.0009L0.669922 43.0009ZM28.25 18.2509V29.5009H23.75V18.2509H28.25ZM23.75 31.7509H28.25V36.2509H23.75V31.7509Z"
            fill="#D50000"
          />
        </svg>
      </Icon>
      {failureSection && (
        <Text
          fontSize={'22px'}
          color={'#D50000'}
          mb={4}
          mt={2}
          as="h2"
          {...ThankYouSt[lang]?.errorTitle}
        >
          {failureSection[0]?.titleText}
        </Text>
      )}
      <TextContainer maxW="400px" mx="auto" mb={8} fontSize={'18px'}>
        {failureSection && (
          <StructuredTextParser
            str={render(failureSection[1]?.body).replace(
              /{errMsg}/g,
              message || pageState?.data?.error?.message
            )}
            lineHeight={{ base: '20px', md: '30px' }}
            fontSize={{ base: '16px', md: '18px' }}
            color="#433F3C"
            textAlign="center"
            className="errorScreen"
            {...ThankYouSt[lang]?.errorSt}
          />
        )}
        <style global jsx>
          {`
            .errorScreen p {
              margin-bottom: 7px;
              font-family: 'FedraSansStd-book';
            }
            .errorScreen p:first-child {
              margin-bottom: 7px;
              font-family: 'FedraSansStd-medium';
            }
            .errorScreen a {
              color: #e86f34;
            }
            .errorScreen a:hover {
              text-decoration: underline;
            }
          `}
        </style>
        <Box borderTop={'solid 1px #E9E8E8'} w={'100%'} mb={6} />
      </TextContainer>
      <Grid
        templateColumns={{ base: 'auto', sm: 'auto auto' }}
        gridColumnGap={6}
        gridRowGap={1}
        w={{ base: 'full', lg: '70%' }}
        mx="auto"
        justifyContent={'space-between'}
        textAlign={'left'}
        fontFamily={'FedraSansStd-book'}
      >
        {pageState.transactionId
          ? [
              {
                label:
                  thankyouSection[5]?.data?.transactionid ||
                  t('success.transactionId'),
                value: pageState?.transactionId,
              },
            ]
              .filter(item => item.value)
              .map(({ label, value }) => (
                <>
                  {value && value.indexOf('undefined') < 0 && (
                    <>
                      <Box color="#747474">{label}:</Box>
                      <Box
                        fontFamily="FedraSansStd-book"
                        fontWeight="600"
                        mb="10px"
                        color="#433F3C"
                      >
                        {value}
                      </Box>
                    </>
                  )}
                </>
              ))
          : ''}
      </Grid>
    </Flex>
  );
};
